import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var config = {
  apiKey: "AIzaSyAYwNxTv53WNzgr0B4GrSI2k8i4mDIoccQ",
  authDomain: "learn-maps-30649.firebaseapp.com",
  databaseURL: "https://learn-maps-30649.firebaseio.com",
  projectId: "learn-maps-30649",
  storageBucket: "learn-maps-30649.appspot.com",
  messagingSenderId: "173839749074"
};
firebase.initializeApp(config);

export default firebase 


// WEBPACK FOOTER //
// ./src/config/fbConfig.js